import {
  SET_EMPLOYERS_AND_ROLES,
  SET_EMPLOYER_DIALOG,
} from '@/store/mutation-types';
import {
  getEmployerAndRoleList,
  getEmployerAndRolesById,
  createNewEmployer,
  updateEmployer,
} from '@/services/employer-service';

const actions = {
  getEmployerAndRoleList({ commit, rootState }, options = {}) {
    const agentId = rootState.attendance.Attendance.agentId;
    return getEmployerAndRoleList(agentId, options).then((response) => {
      const items = response.data.data;
      commit(SET_EMPLOYERS_AND_ROLES, items);
      return response.data.total;
    });
  },
  createNewEmployer({ dispatch, rootState }, params) {
    const agentId = rootState.attendance.Attendance.agentId;
    params.agentId = agentId;
    return createNewEmployer(params)
      .then((response) => {
        switch (response.status) {
          case 200:
            dispatch(
              'showSnackbar',
              {
                text: 'contactManagement.employerForm.' + response.data.message,
                type: 'success',
              },
              { root: true },
            );
            return response.data;
          case 409:
            dispatch(
              'showSnackbar',
              {
                text: 'contactManagement.employerForm.' + response.data.message,
                type: 'success',
              },
              { root: true },
            );
            return false;
          case 500:
            dispatch(
              'showSnackbar',
              {
                text: 'contactManagement.employerForm.' + response.data.message,
                type: 'error',
              },
              { root: true },
            );
            return false;
          default:
            return false;
        }
      })
      .catch((response) => {
        console.log(response);
      });
  },
  updateEmployer({ dispatch, rootState }, params) {
    const agentId = rootState.attendance.Attendance.agentId;
    params.agentId = agentId;
    return updateEmployer(params.employerId, params)
      .then((response) => {
        switch (response.status) {
          case 200:
            dispatch(
              'showSnackbar',
              {
                text: 'contactManagement.employerForm.' + response.data.message,
                type: 'success',
              },
              { root: true },
            );
            return true;
          case 409:
            dispatch(
              'showSnackbar',
              {
                text: 'contactManagement.employerForm.' + response.data.message,
                type: 'success',
              },
              { root: true },
            );
            return false;
          case 500:
            dispatch(
              'showSnackbar',
              {
                text: 'contactManagement.employerForm.' + response.data.message,
                type: 'error',
              },
              { root: true },
            );
            return false;
          default:
            return false;
        }
      })
      .catch((response) => {
        console.log(response);
      });
  },
  showEmployerDialog({ commit }, params) {
    commit(SET_EMPLOYER_DIALOG, params);
  },
  async getEmployerInformation({}, employerId) {
    return await getEmployerAndRolesById(employerId).then((response) => {
      return response;
    });
  },
};

export default actions;
